import { ReportDefinition } from './report-definition.model';
import { NameValueBool } from './name-value-bool.model';
import { DataSource } from './data-source.model';


export class ReportParameter {
  Id: number;
  RC_ID: number;
  Name: string;
  ColumnName: string;
  ParameterName: string;
  ShowAll: boolean;
  IsParent: boolean;
  Value: any; // parameter values can bes strings, dates, bools, etc.
  DataType: string;
  ControlType: string;
  DataSource: DataSource[];
  MultiValue: string[];
  MaxLength: number;
  ParameterReportDefinition: ReportDefinition;
  ParameterOptions: NameValueBool[];
  //////////////////////////////
  RowNumberInTable: number;
  ColumnNumberInTableCell: number;
  Colspan: number;
  HighlightParameter: boolean; // when coming from other areas such as a selected student or course
  SetBackgroundColorForSavedDefinition: boolean;

  // ONE-2400 - groups/sorting

  ParameterHasBeenAddedToRow: boolean;

  OrdinalPosition: number; // we will set this to the Id (zero based consecutive) for now since the sp (spOneSIS_GetProcedureParameters) for pulling parameters returns them by OrdinalPosition
  SortOrder: number; // this is the order we will display parameters
  IsInGroup: boolean;
  Group_ID: number;
  IncludeGroupLabel: boolean;
  GroupLabel: string; // only set on first parameter in group
  // GroupName: string; // unnecessary for now
  IncludeLineAtStartOfGroup: boolean;
  IncludeLineAtEndOfGroup: boolean;
  GroupSortOrder: number; // this is at GROUP level and NOT parameter in group level
  // GroupParameterSortOrder: number;
  IsStartOfVisibleGroup: boolean;
  IsEndOfVisibleGroup: boolean;
  EntireGroupIsHidden: boolean;

  // ONE-2400 - formatting options

  HasFormatting: boolean;
  NoWrap: boolean;
  ShowOptionsVertically: boolean;
  SpanEntireRow: boolean;
  SpanNumberOfColumns: number;
  IsVisible: boolean;
  IsSystemHiddenParameter: boolean;

  parameterId: number;

  // IsFromGradeBook: boolean;
  // IsEmailDistributionParameter: boolean;
  // IsHiddenParameterPassedFromApp: boolean;



  getMultiValue_Labels(): string[] {
    const labels: string[] = [];
    for (let d = 0; d < this.DataSource.length; d++) {
      labels.push(this.DataSource[d].TextField);
    }
    return labels;
  }

  getMultiValue_StringValues(): string[] {
    const values: string[] = [];
    for (let d = 0; d < this.DataSource.length; d++) {
      values.push(this.DataSource[d].ValueField);
    }
    return values;
  }

  getMultiValue_BoolValues(): boolean[] {
    const values: boolean[] = [];
    for (let d = 0; d < this.DataSource.length; d++) {
      values.push(this.DataSource[d].IsSelected);
    }
    return values;
  }


  getMultiValue_Ids(): string[] {
    const ids: string[] = [];
    for (let d = 0; d < this.DataSource.length; d++) {
      ids.push('MultiVal_' + this.Id + '_' + d.toString());
    }
    return ids;
  }

}



